import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumDeleteCancelPopup3({
  onDone,
} : {
  onDone: () => void,
}) {
  return (
    <PopupContainer title="リリースの配信停止について" onClose={() => { onDone(); }}>
      <form>
        <div className="list__body">
          <p>配信停止依頼を送信しました。</p>
          <p>配信停止までには最大で1ヶ月ほどかかります。</p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { onDone(); }}>配信の管理へ</CustomButton>
              <CustomButton type="default-split" onClick={() => { document.location.href = '/'; }}>ホームへ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
